import React, { useState, useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import './Login.css'
import { API_BASE_URL } from '../api'

function Login({ setUserRole }) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  const navigateToDashboard = useCallback((role) => {
    if (role === 'user') {
      navigate('/member-dashboard')
    } else if (role === 'admin') {
      navigate('/admin-dashboard')
    } else if (role === 'trainer') {
      navigate('/trainer-dashboard')
    } else {
      navigate('/dashboard')
    }
  }, [navigate])

  useEffect(() => {
    const storedSession = localStorage.getItem('session')
    if (storedSession) {
      const sessionData = JSON.parse(storedSession)
      setUserRole(sessionData.user.role)
      navigateToDashboard(sessionData.user.role)
    }
  }, [navigate, setUserRole, navigateToDashboard])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      const response = await fetch(`${API_BASE_URL}/signin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      })
  
      if (response.ok) {
        const data = await response.json()
        setMessage(data.message)
        const role = data.role
        setUserRole(role)
        
        // Store session data in localStorage
        localStorage.setItem('session', JSON.stringify(data.session))
        
        navigateToDashboard(role)
      } else {
        const errorText = await response.text()
        setMessage(errorText)
      }
    } catch (error) {
      console.error('Error during login:', error)
      console.error('Error details:', error.message)
      setMessage('An error occurred during login: ' + error.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className='login'>
      <div className='login__container'>
        <form className='login__form' onSubmit={handleSubmit}>
          <h1 className='login__title'>Login</h1>
          <input
            type='text'
            placeholder='Username'
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className='login__input'
            required
          />
          <input
            type='password'
            placeholder='Password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className='login__input'
            required
          />
          <button type='submit' className='login__button' disabled={loading}>
            {loading ? 'Loading...' : 'Log In'}
          </button>
        </form>
        {loading && (
          <div className='login__loading'>
            <svg className="ip" viewBox="0 0 256 128" width="128px" height="64px" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id="grad1" x1="0" y1="0" x2="1" y2="0">
                  <stop offset="0%" stopColor="#5ebd3e" />
                  <stop offset="33%" stopColor="#ffb900" />
                  <stop offset="67%" stopColor="#f78200" />
                  <stop offset="100%" stopColor="#e23838" />
                </linearGradient>
                <linearGradient id="grad2" x1="1" y1="0" x2="0" y2="0">
                  <stop offset="0%" stopColor="#e23838" />
                  <stop offset="33%" stopColor="#973999" />
                  <stop offset="67%" stopColor="#009cdf" />
                  <stop offset="100%" stopColor="#5ebd3e" />
                </linearGradient>
              </defs>
              <g fill="none" strokeLinecap="round" strokeWidth="16">
                <g className="ip__track" stroke="#ddd">
                  <path d="M8,64s0-56,60-56,60,112,120,112,60-56,60-56"/>
                  <path d="M248,64s0-56-60-56-60,112-120,112S8,64,8,64"/>
                </g>
                <g strokeDasharray="180 656">
                  <path className="ip__worm1" stroke="url(#grad1)" strokeDashoffset="0" d="M8,64s0-56,60-56,60,112,120,112,60-56,60-56"/>
                  <path className="ip__worm2" stroke="url(#grad2)" strokeDashoffset="358" d="M248,64s0-56-60-56-60,112-120,112S8,64,8,64"/>
                </g>
              </g>
            </svg>
          </div>
        )}
        {message && <p className='login__message'>{message}</p>}
      </div>
    </div>
  )
}

export default Login
